// cookieyesConsent.js
/**
 * Call `cb()` as soon as "advertisement" consent is granted.
 * - Runs immediately if consent is already granted
 * - Also runs on future consent updates (banner interaction)
 */
export function onAdsConsent(cb) {
  const tryRun = () => {
    try {
      // Newer CookieYes exposes getCkyConsent()
      if (typeof window.getCkyConsent === "function") {
        const c = window.getCkyConsent();      // object with categories/choices
        const granted =
          !!(c?.categories?.advertisement) ||  // common shape
          (Array.isArray(c?.acceptedCategories) && c.acceptedCategories.includes("advertisement"));
        if (granted) cb();
        return granted;
      }
    } catch (_) { /* noop */ }
    return false;
  };

  // 1) Fire immediately if already granted (e.g., returning visitor)
  if (tryRun()) return;

  // 2) Otherwise, run when the user updates consent on the banner
  // CookieYes dispatches a custom event when consent changes.
  const handler = () => { tryRun(); };
  window.addEventListener("cookieyes_consent_update", handler);

  // Optional: also try once when the banner finishes loading
  window.addEventListener("cookieyes_banner_loaded", handler);
}
